import { Component, OnInit } from '@angular/core';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { IdentificationService } from 'src/app/shared/services/identification/identification.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { PostValidateService } from 'src/app/shared/services/post-validate/post-validate.service';
import { ProductLoaderService } from 'src/app/shared/services/product-loader/product-loader.service';

import { RISK_LEVELS } from '../../../shared/constants/rate.constants';
import { OpEnum } from '../../../shared/enums/op.enum';
import { DocumentModel } from '../../../shared/models/document.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { RequestService } from '../../../shared/services/request/request-onboarding.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { callbackAdjustContratarTC } from 'src/app/shared/constants/adjust-callback';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

@Component({
  selector: 'app-gray-zone',
  templateUrl: './gray-zone.component.html',
  styleUrls: ['./gray-zone.component.scss'],
})
export class GrayZoneComponent implements OnInit {

  loadExitScreen = false;
  options: [any];
  screenCopies: any;
  screenCopies_title: any;
  product_type: string;
  product_code: string;
  documentInfo: DocumentModel;
  amount: any;
  mes: any;
  taxRates: any;
  amountPco: any;
  taxInfo: any;
  codBizagi: any;
  segment_id: any;
  showRate = false;
  /* Tipo de living place
  * leasing, cartera o hiptecario
  */
  subtype: any;
  /* Sublinea relacionada al subtype
  */
  codesubline: string;
  /* Nombre Sublinea relacionada al subtype
  */
  subline: string;
  /* Porcentaje de opcion de compra
  * Solo aplica para sublinea leasing habitacional
  * purchase: true or false
  * purchasePercent: % entregado por el simulador
  */
  purchase: any;
  purchasePercent: any;
  /* si es valor solicitado o monto aprobado en el label
  * monto para hipotecario y valor para leasing y cartera
  */
  labelValue: string;
  /* aprobado o aprobada
  * aprobado para hipotecario y leasing aprobada para cartera
  */
  textApproved: string;
  /* Monto inicial solicitado de acuerdo a PCO
  */
  initial_amount: any;
  initAmount: any;
  /* Monto a mostrar
  * aprobado si es hipotecario
  * solicitado si es cartera o leasing
  */
  showAmount: any;
  /* rate para living
  */
  rateLiving: any;
  continueRelated: boolean;
  /* datos del simulador
  */
  simulator: any;
  /**
   * Numero de caso entregado por Bizagi
   */
  caseNum: any;
  prueba: any;
  valor: any;
  loanBenefits: any;
  productsMultiSelcted: any = [];
  readonly RISK_LEVELS = RISK_LEVELS;
  IsMulti: boolean;
  productsSelects: any = [];
  isNormalizacion = false;
  channelId;
  constructor(
    public copyService: CopyService,
    private captureService: CaptureService,
    private headerService: HeaderService,
    public navigationService: NavigationService,
    private parametersService: ParametersService,
    public abreCuentasService: AbreCuentasService,
    private requestService: RequestService,
    private validationHelperService: ValidationHelperService,
    private bitacoraService: BitacoraService,
    private productLoaderService: ProductLoaderService,
    public helperService: HelpersService,
    private postValidate: PostValidateService,
    private bioCatchService: BioCatchService,
    public channelCommunicatorService: ChannelCommunicatorService,
    private identificationService: IdentificationService,
    private adjustEvent: AdjustEvent,
    private taggingService: TaggingService,
  ) {
    this.headerService.show(false, true, true);
    this.channelId = this.channelCommunicatorService.getChannelId();
  }

  ngOnInit() {
    this.sendTagging('init');
    this.IsMulti = this.abreCuentasService.viewOptionMultiProduct;
    this.prueba = this.copyService.copies.message_grayzone_existent;
    this.screenCopies = {};
    this.screenCopies_title = {};
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    const productSelected = this.abreCuentasService.getproductSelected();
    const preLoginOnly = this.bioCatchService.isEvidenteCase();
    const isOriginal = this.bioCatchService.isAppCN();
    this.bioCatchService.changeContext(StepBiocatchEnum.oferta, product, isOriginal, preLoginOnly);
    this.product_type = productSelected.product_type;
    this.product_code = productSelected.product_code;
    this.codBizagi = this.abreCuentasService.getSolicitationId();
    if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE) {
      this.amount = this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue !== undefined ?
        this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue : ' ';
      this.mes = this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue;
      this.segment_id = this.abreCuentasService.getinfoInferredIncomes().segment_id;
      this.amountPco = this.amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').split(/\ /).join('').trim();
      const rates = this.requestService.getRates();
      this.rateLiving = `${rates[0].value}% ${rates[0].type}  (${rates[1].value}% ${rates[1].type})`;
      this.getRates();
    }
    if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      this.bitacoraService.saveDataInBitacora('offer_pco_zg');
      const resultpc = this.abreCuentasService.getPcoModel();
      const rates = this.requestService.getRates();
      this.rateLiving = `${rates[0].value}% ${rates[0].type}  (${rates[1].value}% ${rates[1].type})`;
      this.simulator = this.abreCuentasService.getSimulatorModel();
      this.mes = this.simulator.term;
      this.caseNum = resultpc.solicitation_id;
      this.initial_amount = this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue.toString();
      this.initAmount = this.initial_amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').split(/\ /).join('').trim();
      this.subtype = this.simulator.product_subtype;
      this.subline = this.simulator.product_name;
      this.codesubline = this.simulator.product_subline;
      this.purchase = this.validationHelperService.ispurchase();
      this.purchasePercent = this.simulator.purchase;
      // To do get Rates for living
      this.getRates();
    }

    // MULTIPRODUCTO
    if (this.product_type === BUSINESS_CONST.MULTI) {
      this.bitacoraService.saveDataInBitacora('offer_pco_zg');
      const resultpc = this.abreCuentasService.getPcoModel();
      this.productsMultiSelcted = this.abreCuentasService.getProductsSelects();
      this.productsMultiSelcted = this.productsMultiSelcted.find(item => item.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE);
      if (!this.abreCuentasService.haveLoan && this.requestService.getRates()) {
        const rates = this.requestService.getRates();
        this.rateLiving = `${rates[0].value}% ${rates[0].type}  (${rates[1].value}% ${rates[1].type})`;
      } else {
        this.rateLiving = this.abreCuentasService.getRatesLoan();
      }
      this.simulator = this.abreCuentasService.getSimulatorModel();
      this.showAmount = this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue !== undefined ?
        this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue : ' ';
      this.showAmount = this.showAmount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').split(/\ /).join('').trim();
      this.mes = this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue;
      this.caseNum = resultpc.solicitation_id;
      // this.valor = this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue;
      // To do get Rates for living
      this.getRates();
      if (this.abreCuentasService.haveLoan) {
        this.isDeleteloanByNormalization(resultpc);
      }
    }

    // LIBRANZA
    if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
      this.amount = this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue !== undefined ?
        this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue : ' ';
      this.mes = this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue;

      if (!this.abreCuentasService.getProspectResponse().client) {
        this.segment_id = this.abreCuentasService.getinfoInferredIncomes().segment_id;
      }

      this.amountPco = this.amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').split(/\ /).join('').trim();
      this.loanBenefits = this.parametersService.getSetting(OpEnum.LOAN_BENEFITS_OFFER);
      this.rateLiving = this.abreCuentasService.getRatesLoan();
      this.showRate = true;
    }

    this.documentInfo = this.abreCuentasService.getDocumentInfo();
    this.setCopies(this.product_type);
  }

  isDeleteloanByNormalization(responsePco) {
    const foundLoan = responsePco.granted_product_multi.find(item => item.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN);
    const selectedProdInit = this.abreCuentasService.getProductsSelects();
    if (!foundLoan) {
      this.abreCuentasService.setWasDeleteLoan(true);
      const flow = selectedProdInit.filter(item => item.product_type !== BUSINESS_CONST.PRODUCT_TYPE_LOAN);
      this.abreCuentasService.setProductsSelects(flow);
    }
  }

  getRates() {
    this.taxRates = this.requestService.getRates();
    this.showRate = true;
  }

  isGranted(product_type: string) {
    const productsGranted = this.abreCuentasService.getPcoModel().granted_product_multi;
    const granteds = productsGranted.filter(i => i.product_type === product_type);
    return granteds.length > 0;
  }

  setCopies(product_type) {
    this.screenCopies_title = {
      mailInfo: 'Te enviaremos a tu correo electrónico los documentos requeridos para la solicitud de tu crédito.',
      documentsInfo: `Consulta los <a (click)="showRequiredDocuments()"><u>documentos</u></a>` +
        ` que necesitarás para realizar esta solicitud.`,
      caseLabel: 'Número de caso',
    };
    switch (product_type) {
      case BUSINESS_CONST.PRODUCT_TYPE_REVOLVING:
        this.screenCopies = this.copyService.copies.gray_zone_type_revolving;
        break;
      case BUSINESS_CONST.PRODUCT_TYPE_FREE:
        this.screenCopies = this.copyService.copies.gray_zone_type_free;
        this.options = this.parametersService.getSetting(OpEnum.FREE_CREDIT_CHARACTERISTICS);
        break;
      case BUSINESS_CONST.PRODUCT_TYPE_LIVING:
        this.screenCopies = this.copyService.copies.gray_zone_living;
        this.textApproved = ((this.subtype === 'LEA' && this.codesubline === '03')
          || (this.subtype === 'HIP' && this.codesubline === '55'))
          ? this.screenCopies.spanText2 : this.screenCopies.spanText;
        this.showAmount = this.initAmount;
        this.labelValue = this.screenCopies.valor;
        this.options = this.parametersService.getSetting(OpEnum.LIVING_CHARACTERISTICS);
        break;
      case BUSINESS_CONST.MULTI:
        this.screenCopies = this.copyService.copies.gray_zone_multi;
        this.productsMultiSelcted = this.abreCuentasService.getProductsSelects();
        this.productsSelects = this.abreCuentasService.getProductsSelects();
        this.screenCopies.head_description_aux = this.screenCopies.head_description_multi;
        this.productsMultiSelcted = this.productsMultiSelcted.find(item => item.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE);
        if (this.productsMultiSelcted) {
          this.mes = this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue;
          this.initial_amount = this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue.toString();
          this.initAmount = this.initial_amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').split(/\ /).join('').trim();
          this.showAmount = this.initAmount;
        }
        break;
      case BUSINESS_CONST.PRODUCT_TYPE_LOAN:
        this.rateLiving = this.abreCuentasService.getRatesLoan();
        this.screenCopies = this.copyService.copies.gray_zone_loan;
        this.productsMultiSelcted = this.abreCuentasService.getproductSelected();
        break;
      default:
        break;
    }
  }

  /**
   * Summary Go to next Step
   */
  async next() {
    this.sendTagging('next', 'center' , '2');
    if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      this.productLoaderService.show(this.copyService.copies.show_offer_pco,
        this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['ALTA']);      // // Relacionados
      // await this.checkRelated();
      // if (!this.continueRelated) {
      //   this.productLoaderService.hide();
      //   return;
      // }
      try {
        await this.postValidate.createClient();
        await this.postValidate.createProducts();
        await this.postValidate.performSolicitation();
        this.bitacoraService.saveDataInBitacora('Ini_loading_Product');
        await this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['ALTA']);
        await this.captureService.getChannelComunicator(true).then((res2: any) => {
          if (res2 === '208') {
            this.bitacoraService.saveDataInBitacora('Possible_fraud_Yes');
          } else if (res2 === '20-04') {
            res2 = '208';
            this.bitacoraService.saveDataInBitacora('Possible_fraud_incident');
          }
          (res2 === '107' || res2 === '121' || res2 === '130' || res2 === '129' || res2 === '124' || res2 === '127') ?
            this.navigationService.navigateToGeneralInformation(res2) :
            this.navigationService.nextStep(res2);
          if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC && res2 === '121') {
            const event = {
              eventToken: 'huswfn',
              callbackParams: callbackAdjustContratarTC,
            };
            this.adjustEvent.adjustTrackEvent(event);
          }
          this.bitacoraService.saveDataInBitacora('Out_loading_Product');
          this.productLoaderService.hide();
        }).catch(() => this.navigationService.navigateToGeneralInformation('107'));
      } catch (error) {
        this.navigationService.navigateToGeneralInformation('107');
      }
      this.bitacoraService.saveDataInBitacora('product_accepted_approved');
      return;
    }
    this.navigationService.nextStep('200');
  }

  async checkRelated() {
    this.continueRelated = true;
    let document = this.abreCuentasService.getDocumentInfo().document_number;
    const resInfo = await this.identificationService.validateIfIsRelated(document);
    console.log('resInfo');
    console.log(resInfo);
    if (!resInfo.related) { return; }
    // BITÁCORA CON employee_members
    const bitacoraEvent = `employee_members`;
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);

    // Verificar estado PCO
    const pcoStatus = this.abreCuentasService.getPcoModel().solicitation_status.status_code;
    console.log('pcoStatus');
    console.log(pcoStatus);
    // PCO Aprobado continúa a "Tu solicitud fue recibida y la estamos validando"
    if (pcoStatus !== 'PCO01') { return; }
    this.navigationService.nextStep('203');
    this.productLoaderService.hide();
    this.continueRelated = false;
  }

  previous() {
    this.sendTagging('prev', 'center' , '1');
    this.bitacoraService.saveDataInBitacora('mejor_otro_dia_pco');
    this.navigationService.navigateToGeneralInformation('512');
  }

  showRequiredDocuments() {
    this.navigationService.nextStep('202');
  }

  goExit() {
    this.navigationService.nextStep('106');
  }

  closeApp() {
    this.loadExitScreen = true;
  }

  listBenefits(row: any) {
    return this.parametersService.getSetting(row.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ? row.options_gray_zone : row.options);
  }

  sendTagging(value: any, position?: string, event?: string) {
    const page = '6';
    const extras = {
      object: 'transactionProductCategory',
      value: 'ZonaGris',
      pageValue: 'GrayZone',
    };
    this.taggingService.sendTaggValues(value, page, position, event, extras);
  }
}
